var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c(
        "b-form-radio-group",
        {
          model: {
            value: _vm.selectedGlazing,
            callback: function ($$v) {
              _vm.selectedGlazing = $$v
            },
            expression: "selectedGlazing",
          },
        },
        [
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h5", [_vm._v("Standard Glass")]),
              _vm._l(_vm.glazingOptions.Standard, function (glazing, idx) {
                return _c(
                  "b-form-radio",
                  {
                    key: `Standard-${idx}`,
                    staticClass: "w-100",
                    attrs: { value: glazing },
                  },
                  [
                    _c("glazing-option", {
                      attrs: {
                        glazing: glazing,
                        "frame-size": _vm.frameSize,
                        "base-price": _vm.basePrice,
                        "group-id": _vm.groupId,
                        included: "",
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h5", [_vm._v("Acrylic Glass")]),
              _vm._l(_vm.glazingOptions.Acrylic, function (glazing, idx) {
                return _c(
                  "b-form-radio",
                  {
                    key: `Acrylic-${idx}`,
                    staticClass: "w-100",
                    attrs: { value: glazing },
                  },
                  [
                    _c("glazing-option", {
                      attrs: {
                        glazing: glazing,
                        "frame-size": _vm.frameSize,
                        "base-price": _vm.basePrice,
                        "group-id": _vm.groupId,
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("h5", [_vm._v("Specialist Glass")]),
              _vm._l(_vm.glazingOptions.Specialist, function (glazing, idx) {
                return _c(
                  "b-form-radio",
                  {
                    key: `Specialist-${idx}`,
                    staticClass: "w-100",
                    attrs: { value: glazing },
                  },
                  [
                    _c("glazing-option", {
                      attrs: {
                        glazing: glazing,
                        "frame-size": _vm.frameSize,
                        "base-price": _vm.basePrice,
                        "group-id": _vm.groupId,
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }